width-observer {
  display: block;
}
